import React, { useEffect, useRef, useState } from "react";
import { deserialize, serialize } from "serializr";
import { Form, Formik } from "formik";
import { useLocation } from "react-router-dom";


import "./products.scss";

import ProductList from "./ProductLists";
import ProductViewer from "./ProductViewer";
import ProductForm from "./ProductForm";

import { Col, Row, Skeleton } from "antd";
import Filters from "../../shared/components/Filters";
import AppHeader from "../../shared/components/AppHeader";
import DeleteAlert from "../../shared/components/DeleteAlert";
import EmptyState from "../../shared/components/EmptyState";
import DropdownField from "../../shared/components/DropdownField";
import BulkUpload from "../CourseStructure/Chapters/ChapterActions/BulkUpload";
import PaginationComponent from "../../shared/components/PaginationComponent";


import { MetaModel } from "../../models/CourseModels/SubjectModel/subject.model";
import { FilterProducts, deleteProductModel } from "../../models/ProductModel/products.model";

import ProductService from "../../services/ProductService/products.service";
import CommonService from "../../services/CommonService/common.service";
import { convertJSONToFormData } from "../../shared/utils/converJsonToFormData";



const ProductsLibrary = () => {
  const [currentContent, setCurrentContent] = useState<any>("");
  const [showContent, setShowContent] = useState<boolean>(false);
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const [formVisible, setFormVisible] = useState<boolean>(false);
  const [contents, setContents] = useState<any>([]);

  const [paginationMeta, setPaginationMeta] = useState<any>([]);
  const [showFilter, setFilterVisibility] = useState(false);
  const [showBulkUpload, setBulkUpload] = useState<boolean>(false);

  const [loading, setLoading] = useState(false);
  const [loadingContentsList, setLoadingContentsList] = useState(false);

  const formRef = useRef<any>();
  const defaultFilter = { CurrentPage: 1, Pagesize: 12 }
  const [filters, setFilters] = useState<FilterProducts>(defaultFilter);

  const [boards, setBoards] = useState<MetaModel[]>([]);
  const [classRooms, setClassRooms] = useState<MetaModel[]>([]);

  const fetchBranchClassRooms = (BoardId: number | string) => {
    setLoading(true)
    CommonService.fetchGradeMetaByBoard(
      BoardId,
      (data) => {
        const meta = deserialize(MetaModel, data) as MetaModel[];
        if (meta.length) {
          setClassRooms(meta);
        }
      },
      () => { },
      () => { setLoading(false) }
    );
  };

  const fetchBoards = () => {
    setLoadingContentsList(true)
    CommonService.fetchBoardsMeta(
      (data) => {
        const response = deserialize(MetaModel, data) as MetaModel[];
        setBoards(response);
        if (response.length > 0 && response[0].value !== undefined) {
          const BoardId = response[0].value;
          setFilters({ ...filters, BoardId })
          fetchBranchClassRooms(BoardId)
          setLoadingContentsList(false)
          fetchProductList({ ...filters, BoardId, ClassId: 0 });
        }
      },
      () => { setLoadingContentsList(false) },
      () => { }
    );
  };

  useEffect(() => {
    fetchBoards()
  }, []);


  const fetchProductList = (queryParams: FilterProducts) => {
    setLoadingContentsList(true);
    ProductService.getProductList(
      queryParams,
      (contentLibrary: any, pageMeta: any) => {
        setContents(contentLibrary);
        setPaginationMeta(pageMeta);
        setLoadingContentsList(false);
      },
      () => { },
      () => { }
    ).then();
  };


  const handlePageChange = (page: number, pageSize: any) => {
    fetchProductList({ ...filters, CurrentPage: page, Pagesize: pageSize });
    setFilters({ ...filters, CurrentPage: page, Pagesize: pageSize });
  };



  const handleDelete = () => {
    setShowDelete(false);
    setLoadingContentsList(true);
    let contentData = serialize(deleteProductModel, currentContent);
    contentData.IsActive = false
    let contentFormData = convertJSONToFormData(contentData);
    ProductService.deleteProduct(
      contentFormData,
      () => {
        setLoadingContentsList(false);
        fetchProductList(filters);
      },
      () => { setLoadingContentsList(false); },
      () => { }
    ).then();
  };

  return (
    <div className="page-view">
      <AppHeader
        buttonText="Product"
        handleHeaderAction={() => setFormVisible(true)}
        showFilter={true}
        headerText="Products"
        handleFilter={() => setFilterVisibility(true)}
      />
      <BulkUpload
        visible={showBulkUpload}
        closeHandler={() => {
          setBulkUpload(false);
        }}
      />

      {loadingContentsList
        ? <>
          {[1, 2, 3, 5].map(rw => <Row key={"ROW#" + rw} className="content-list" gutter={[24, 12]}>
            {[1, 2, 3, 5].map(ske => <Col key={"COL#" + ske} xs={8} xl={6}>
              <div className="content-list__card" style={{ padding: 20 }}>
                <Skeleton active />
              </div>
            </Col>)}
          </Row>)}
        </>
        : contents.length !== 0 ? (
          <>
            <ProductList
              contents={contents}
              currentContent={currentContent}
              setCurrentContent={setCurrentContent}//fetchContentDetails
              setShowContent={setShowContent}
              setShowDelete={setShowDelete}
              setShowForm={setFormVisible}
              setShowQuickQuizForm={() => { }}
            />
            <div className="content-library__footer">
              <PaginationComponent
                handlePageChange={handlePageChange}
                paginationMeta={paginationMeta}
              />
            </div>
          </>
        ) : (
          <EmptyState text={"No Products found."} />
        )}
      <ProductViewer
        visible={showContent}
        setVisible={setShowContent}
        content={currentContent}
        setCurrentContent={setCurrentContent}

      />
      <DeleteAlert
        visible={showDelete}
        setVisible={setShowDelete}
        deleteText={currentContent?.productName + " Product"}
        deleteWarning="This Product will be deleted permanently"
        contentThumbnail={currentContent?.displayPictureUrl}
        contentTitle={currentContent?.title}
        handleDelete={handleDelete}
      />
      <ProductForm
        loading={loading}
        title={currentContent === '' ? 'New Product' : ` Edit Product`}
        visible={formVisible}
        setVisible={setFormVisible}
        data={currentContent}
        setCurrentContent={setCurrentContent}
        refreshData={() => fetchProductList(filters)}
      />


      <Formik
        initialValues={filters}
        onSubmit={() => { }}
        enableReinitialize
        innerRef={formRef}
      >
        {({ values, setFieldValue, resetForm }) => (
          <Filters
            expand={showFilter}
            handleApply={() => {
              fetchProductList(values)
              setFilterVisibility(false)
            }}
            handleReset={() => {
              resetForm({});
              setFilterVisibility(false);
              setFilters(defaultFilter)
              fetchBoards()
            }}
            closeHandler={() => setFilterVisibility(false)}
          >
            <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <div className="filter-form__input">
                <div className="filter-form__label">Branch</div>
                <DropdownField
                  name="BoardId"
                  placeholder="Select branch"
                  options={boards}
                  value={values?.BoardId}
                  onChange={(value) => {
                    setFieldValue("BoardId", value);
                    setFieldValue("ClassId", null);
                    fetchBranchClassRooms(value);
                  }}
                  showSearch={false}
                  optionFilterProp="label"
                />
              </div>
              <div className="filter-form__input">
                <div className="filter-form__label">Class</div>
                <DropdownField
                  name="GradeId"
                  placeholder="Select class"
                  options={classRooms}
                  value={values?.ClassId}
                  onChange={(value) => {
                    setFieldValue("ClassId", value);
                  }}
                  showSearch={false}
                  optionFilterProp="label"
                />
              </div>
            </Form>
          </Filters>
        )}
      </Formik>

    </div>
  );
};

export default ProductsLibrary;
